import { quadOut, quartInOut } from 'svelte/easing';
import { fly } from 'svelte/transition';

export function transitionIn(node: Element) {
    return fly(node, {
        delay: 0,
        duration: 300,
        easing: quadOut,
        y: -60,
        opacity: 0.5,
    });
}

export function transitionOut(node: Element) {
    return fly(node, {
        delay: 0,
        duration: 300,
        easing: quartInOut,
        y: 60,
        opacity: 0,
    });
}
